import { Card, Stack, Row, Col } from "react-bootstrap";
import { CardTitle } from "../components/card_components";
import { AppIcon } from "@/components/Icon";
import { useNavigate, useParams } from "react-router-dom";

const STATUS_UI_MAP = {
  under_review: {
    label: "Under review",
    bg: "#FFF4CC",
    color: "#B88200",
  },
  resolved: {
    label: "Resolved",
    bg: "#E6F4F1",
    color: "#1F8A70",
  },
};

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

const TicketRow = ({ ticket }) => {
  const navigate = useNavigate();
  const { loanUUID: loanId } = useParams();
  const statusUI = STATUS_UI_MAP[ticket.status] || {};

  return (
    <Row className="align-items-center py-3 border-bottom mx-0">
      <Col md={2} className="fw-medium">
        {ticket.id}
      </Col>

      <Col md={3} className="text-muted" style={{ minWidth: 0 }}>
        <div className="text-truncate" title={ticket.subject || "-"}>
          {ticket.subject || "-"}
        </div>
      </Col>

      <Col md={3} className="text-muted">
        {formatDate(ticket.created)}
      </Col>

      <Col md={3}>
        <span
          style={{
            backgroundColor: statusUI.bg,
            color: statusUI.color,
            padding: "6px 14px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          {statusUI.label}
        </span>
      </Col>

      <Col md={1} className="text-end">
        {/* ✅ CLICK EYE */}
        <span
          role="button"
          style={{ cursor: "pointer", display: "inline-flex" }}
          onClick={() =>
            navigate(`/lms/${loanId}/tickets/${ticket.uuid}`)
          }
        >
          <AppIcon name="Eye" className="text-muted" />
        </span>
      </Col>
    </Row>
  );
};

export function SupportTicketsList({ tickets = [] }) {
  return (
    <Card className="border-0 rounded-lg h-100">
      <Card.Body className="p-4">
        <Stack gap={3}>
          <CardTitle title="My tickets" />

          {tickets.length > 0 && (
            <Row
              className="fw-semibold py-3 px-2 rounded"
              style={{ background: "#F5F6FA" }}
            >
              <Col md={2}>Ticket ID</Col>
              <Col md={3}>Subject</Col>
              <Col md={3}>Submitted date</Col>
              <Col md={3}>Status</Col>
              <Col md={1} />
            </Row>
          )}

          <Stack>
            {tickets.map((ticket) => (
              <TicketRow key={ticket.uuid} ticket={ticket} />
            ))}
          </Stack>
        </Stack>
      </Card.Body>
    </Card>
  );
}
